import { createSelector } from 'reselect'
import { LoginRootState } from '../loginRoot.reducer'

export const namedRequestInProgress = createSelector(
  [
    (state: LoginRootState) => state.commonStore.requests,
    (state: LoginRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestStatus = createSelector(
  [
    (state: LoginRootState) => state.commonStore.requests,
    (state: LoginRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: LoginRootState) => state.commonStore.requests,
    (state: LoginRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
